import {
	AfterViewInit,
	Component,
	HostBinding,
	Input,
	OnInit
}                       from '@angular/core';
import { BrandEnum }    from '@core/services/brand/brand.enums';
import { BrandService } from '@core/services/brand/brand.service';

export enum LoaderOverlaySvgAlignmentEnum {
	TOP_LEFT = 'topLeft',
	TOP_CENTER = 'topCenter',
	TOP_RIGHT = 'topRight',
	CENTER_LEFT = 'centerLeft',
	CENTER = 'center',
	CENTER_RIGHT = 'centerRight',
	BOTTOM_LEFT = 'bottomLeft',
	BOTTOM_CENTER = 'bottomCenter',
	BOTTOM_RIGHT = 'bottomRight'
}

export enum LoaderOverlaySvgPositionEnum {
	RELATIVE = 'relative',
	FIXED = 'fixed'
}


@Component( {
	selector: 'app-loader[showLoader]',
	templateUrl: './loader.component.html',
	styleUrls: [ './loader.component.scss' ]
} )
export class LoaderComponent implements AfterViewInit, OnInit {

	@Input() idPrefix: string;

	@Input() showLoader: boolean;

	@Input() attribute: string;

	@Input() begin: string;

	@Input() duration: string;

	@Input() repeatCount: string;

	@Input() defaultColor: string;

	@Input() highlightColor: string;

	@Input() effect: string;

	@Input() asOverlay: boolean;

	@Input() overlaySvgAlignment: LoaderOverlaySvgAlignmentEnum;

	@Input() overlaySvgPosition: LoaderOverlaySvgPositionEnum;

	@Input() size: string;

	@Input() hostClass: string;

	@Input() svgClass = '';

	@Input( 'svgClassOperations' )
	set svgClassOperations( classOperation: { operation: string, name: string } ) {

		if ( classOperation.operation === 'add' && !this.svgClass.includes( classOperation.name ) ) {
			this.svgClass += ` ${ classOperation.name }`;
		}

		if ( classOperation.operation === 'remove' ) {
			this.svgClass = this.svgClass.replace( classOperation.name, '' ).trim();
		}
	}

	@HostBinding( 'class' ) baseClass: string;

	svgWidth = 28.2;

	svgHeight = 32;

	rectGapSpace = 0; // 0.14;

	rectsCountPerLine = 5;

	rectWidth = this.svgWidth / this.rectsCountPerLine - this.rectGapSpace;

	rectHeight = 3.6;

	rectsData = [];

	viewInit = false;

	brandEnum = BrandEnum;

	activeBranding: BrandEnum;

	constructor(
		private readonly brandService: BrandService
	) { }

	ngOnInit() {
		this.activeBranding = this.brandService.activeBranding;
	}

	ngAfterViewInit(): void {
		const timeout = setTimeout( () => {
			clearTimeout( timeout );

			this.viewInit = true;

			// Others
			this.asOverlay = this.asOverlay ? this.asOverlay : false;

			// SVG
			this.idPrefix = this.idPrefix ? this.idPrefix : 'loaderAnimation';
			this.attribute = this.attribute ? this.attribute : 'fill';
			this.begin = this.begin ? this.begin : '0s';
			this.duration = this.duration ? this.duration : '3s';
			this.repeatCount = this.repeatCount ? this.repeatCount : 'indefinite';
			this.defaultColor = this.defaultColor ? this.defaultColor : '#15244B';
			this.highlightColor = this.highlightColor ? this.highlightColor : '#4BD2DC';
			this.effect = this.effect ? this.effect : 'circle';
			this.size = this.size ? this.size : 'sm';


			// Classes
			this.svgClass = this.svgClass ? this.svgClass : '';
			this.svgClass = this.asOverlay && this.overlaySvgPosition
											? `${ this.svgClass } ${ this.overlaySvgPosition }`
											: this.svgClass;
			this.svgClass = this.asOverlay && this.overlaySvgAlignment
											? `${ this.svgClass } ${ this.overlaySvgAlignment }`
											: this.svgClass;

			this.baseClass = this.asOverlay ? 'overlay' : '';
			this.baseClass = this.hostClass
											 ? `${ this.baseClass } ${ this.hostClass }`
											 : this.baseClass;
			this.generateRectsData();
		}, 0 );
	}

	generateRectsData() {
		// fill with default colors
		this.rectsData = Array( this.rectsCountPerLine ).fill( [] );

		switch ( this.effect ) {
			case 'circle':
				this.effectCircle( this.rectsCountPerLine );
				break;
			case 'knightRider':
				this.effectKnightRider( this.rectsCountPerLine );
				break;
		}
	}

	effectCircle( amount: number ) {
		// fill with default colors
		const colors = Array( amount + 3 ).fill( this.defaultColor );

		// set highlight color
		this.rectsData = this.rectsData.map( ( itm, position ) => {
			itm = [ ...colors ];
			itm.fill( this.highlightColor, position, position + 3 );

			return itm.join( ';' );
		} );
	}

	effectKnightRider( amount: number ) {
		// fill with default colors
		const colors = Array( amount * 2 + 3 ).fill( this.defaultColor );

		// set highlight color
		this.rectsData = this.rectsData.map( ( itm, position ) => {
			itm = [ ...colors ];

			// forward
			itm.fill( this.highlightColor, position, position + 3 );

			// backwards
			itm.fill( this.highlightColor, amount * 2 - position, amount * 2 - position + 3 );

			return itm.join( ';' );
		} );
	}
}
